import { object, SchemaOf, string } from 'yup';

import { ApproveContractLinesVariables } from '@/graphql/contracts/_generated_/approveContractLines.mutation';


export type Fields = {
  comment: ApproveContractLinesVariables['comment']
};

export const validationSchema: SchemaOf<Fields> = object().shape({
  comment: string()
    .max(500, 'Must be maximum ${max} characters')
    .required(),
});